export default "__VITE_ASSET__CfdNUvO7__"